import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice'

import workerReducer from '../features/workers/workerSlice'

import passwordResetReducer from  '../features/passwordReset/passwordResetSlice'
import subscriptionReducer from '../features/subscription/subscriptionSlice'
import workerAuthReducer from '../features/workerAuth/workerAuthSlice'
import employerJobsitesReducer from '../features/workerJobsites/employerJobsitesSlice'
import currentJobsiteReducer from '../features/currentJobsite/currentJobsiteSlice'
import workHistoryReducer from '../features/workHistory/workHistroySlice'
import selectedWorker from '../features/selectedWorker/selectedWorkerSlice'
import jobsitesReducer from '../features/jobsites/jobsitesSlice'
import workerPasswordResetReducer from '../features/passwordResetWorkers/passwordResetWorkersSlice'
import kyoskReducer from '../features/foremanActions/kyoskSlice';
import inviteReducer from '../features/foremanActions/sendInviteSlice';
import ticketWorkersReducer from '../features/foremanActions/ticketWorkersSlice';
import kioskManagementReducer from '../features/kioskManagement/kioskManagementSlice';
import inactivityReducer from '../features/inactivity/inactivitySlice';

export const store = configureStore({
  reducer: {
    // Users
    auth: authReducer,
    passwordReset: passwordResetReducer,
  
    
    workers: workerReducer,
    selectedWorker: selectedWorker,


  
    workHistory : workHistoryReducer,
    
    subscription: subscriptionReducer,
    //Worker Users 
    workerAuth: workerAuthReducer,
    employerJobsites: employerJobsitesReducer,
    workerPasswordReset: workerPasswordResetReducer,
    
    currentJobsite: currentJobsiteReducer,
    businessJobsites : jobsitesReducer,
    // Foreman Actions
    kyosk: kyoskReducer, //usability of the kyosk feature.
    invitation : inviteReducer,
    ticketWorkers: ticketWorkersReducer,

    //Kiosk Management
    kioskManagement: kioskManagementReducer,

    // Inactivity / auto-logout
    inactivity: inactivityReducer,



  },
});
